import {Container} from "inversify";
import axios, {AxiosInstance} from 'axios';
import "reflect-metadata";

import {TYPES} from "@/injection/types";
import {
  IAccountingSoftwareCodeService,
  IActivityOccurrenceService,
  IActivityService,
  IAddressService,
  IApiService,
  IBookService,
  IContactService,
  IDocumentService,
  IFavoriteDocumentService,
  IInvoiceService,
  IMemberService,
  IMembershipService,
  IOrganizationService,
  IParticipantService,
  IUserService
} from "@/injection/interfaces";
import {
  AccountingSoftwareCodeService,
  ActivityOccurrenceService,
  ActivityService,
  ApiService,
  BookService,
  ContactService,
  DocumentService,
  FavoriteDocumentService,
  InvoiceService,
  MemberService,
  MembershipService,
  OrganizationService,
  ParticipantService,
  UserService
} from "@/services";
import {AddressService} from "@/services/addressService";

const dependencyInjection = new Container();
dependencyInjection.bind<AxiosInstance>(TYPES.AxiosInstance).toConstantValue(axios.create())
dependencyInjection.bind<IApiService>(TYPES.IApiService).to(ApiService).inSingletonScope()
dependencyInjection.bind<IAddressService>(TYPES.IAddressService).to(AddressService).inSingletonScope()
dependencyInjection.bind<IUserService>(TYPES.IUserService).to(UserService).inSingletonScope()
dependencyInjection.bind<IMemberService>(TYPES.IMemberService).to(MemberService).inSingletonScope()
dependencyInjection.bind<IContactService>(TYPES.IContactService).to(ContactService).inSingletonScope()
dependencyInjection.bind<IMembershipService>(TYPES.IMembershipService).to(MembershipService).inSingletonScope()
dependencyInjection.bind<IBookService>(TYPES.IBookService).to(BookService).inSingletonScope()
dependencyInjection.bind<IActivityService>(TYPES.IActivityService).to(ActivityService).inSingletonScope()
dependencyInjection.bind<IActivityOccurrenceService>(TYPES.IActivityOccurrenceService).to(ActivityOccurrenceService).inSingletonScope()
dependencyInjection.bind<IOrganizationService>(TYPES.IOrganizationService).to(OrganizationService).inSingletonScope()
dependencyInjection.bind<IInvoiceService>(TYPES.IInvoiceService).to(InvoiceService).inSingletonScope()
dependencyInjection.bind<IDocumentService>(TYPES.IDocumentService).to(DocumentService).inSingletonScope()
dependencyInjection.bind<IFavoriteDocumentService>(TYPES.IFavoriteDocumentService).to(FavoriteDocumentService).inSingletonScope()
dependencyInjection.bind<IParticipantService>(TYPES.IParticipantService).to(ParticipantService).inSingletonScope()
dependencyInjection.bind<IAccountingSoftwareCodeService>(TYPES.IAccountingSoftwareCodeService).to(AccountingSoftwareCodeService).inSingletonScope()

function useAddressService() {
  return dependencyInjection.get<IAddressService>(TYPES.IAddressService);
}

function useUserService() {
  return dependencyInjection.get<IUserService>(TYPES.IUserService);
}

function useMemberService() {
  return dependencyInjection.get<IMemberService>(TYPES.IMemberService);
}

function useContactService() {
  return dependencyInjection.get<IContactService>(TYPES.IContactService);
}

function useBookService() {
  return dependencyInjection.get<IBookService>(TYPES.IBookService);
}

function useActivityService() {
  return dependencyInjection.get<IActivityService>(TYPES.IActivityService);
}

function useActivityOccurrenceService() {
  return dependencyInjection.get<IActivityOccurrenceService>(TYPES.IActivityOccurrenceService);
}

function useMembershipService() {
  return dependencyInjection.get<IMembershipService>(TYPES.IMembershipService);
}

function useOrganizationService() {
  return dependencyInjection.get<IOrganizationService>(TYPES.IOrganizationService);
}

function useInvoiceService() {
  return dependencyInjection.get<IInvoiceService>(TYPES.IInvoiceService);
}

function useDocumentService() {
  return dependencyInjection.get<IDocumentService>(TYPES.IDocumentService);
}

function useFavoriteDocumentService() {
  return dependencyInjection.get<IFavoriteDocumentService>(TYPES.IFavoriteDocumentService);
}

function useParticipantService() {
  return dependencyInjection.get<IParticipantService>(TYPES.IParticipantService);
}

function useAccountingSoftwareCodeService() {
  return dependencyInjection.get<IAccountingSoftwareCodeService>(TYPES.IAccountingSoftwareCodeService);
}

export {
  dependencyInjection,
  useAddressService,
  useUserService,
  useMemberService,
  useContactService,
  useMembershipService,
  useBookService,
  useActivityService,
  useActivityOccurrenceService,
  useOrganizationService,
  useInvoiceService,
  useDocumentService,
  useFavoriteDocumentService,
  useParticipantService,
  useAccountingSoftwareCodeService
};